import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { Container } from "reactstrap";
import { reactLocalStorage } from "reactjs-localstorage";
import { inject, observer, Provider } from "mobx-react";
import { getRegion } from '../../helper/functions/functions';
import { LSNAME } from "../../helper/constants/constants";

// import HPHongkongStore from "../../stores/HPHongkongStore";
import merchantStore from "../../stores/MerchantStore";
import lateUserStore from "../../stores/LateUserStore";

const store = {
  // HPHongkongStore,
  merchantStore,
  lateUserStore
}
const region = getRegion();
class DefaultRoutes extends Component {

  render() {
    const PrivateRoute = ({ isAllowed, isRolePermission, ...props }) => {
      let allowed = isAllowed
      if (isRolePermission) {
        allowed = true;
      }
      return (
        allowed
          ? <Route {...props} />
          : <Redirect to={`/${region}/dashboard`} />
      )
    }
    const permission = reactLocalStorage.getObject(LSNAME.PERMISSION);
    const plr = (this.props.prop.location.pathname.split('/')[2] !== "kpi" && this.props.prop.location.pathname.split('/')[2] !== "timetable" && this.props.prop.location.pathname.split('/')[2] !== "chat"
      && this.props.prop.location.pathname.split('/')[2] !== "chat-messages"
    ) 
      ? "p-lr-15" : "p-lr-0"
    return (
      <Provider {...store}>
        <Container fluid className={plr}>
          <Switch>
            {this.props.routes.map((route, idx) => {
              return route.component ? (
                route.permission ? (
                  <PrivateRoute
                    isAllowed={permission[route.permission]}
                    // isRolePermission={this.props.specialpermission ? !this.props.specialpermission[route.name] ? false : this.props.specialpermission[route.name] : false}
                    key={idx}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    render={props => <route.component {...props} />}
                  />
                ) : (
                  <Route
                    key={idx}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    render={props => <route.component {...props} />}
                  />
                )
              ) : null;
            })}
            <Redirect from="/" to={`/${region}/dashboard`} />
          </Switch>
        </Container>
      </Provider>
    );
  }
}

export default inject("authStore", "commonStore")(observer(DefaultRoutes));